let errorNotifier: ((text: string) => void) | null = null

export function registerRequestErrorNotifier(notifier: (text: string) => void) {
    errorNotifier = notifier
    return () => { if (errorNotifier === notifier) errorNotifier = null }
}

export function isRequestCanceled(error: any) {
    return error?.code === 'ERR_CANCELED' || error?.__CANCEL__ === true
}

export function requestErrorMessage(error: any): string {
    const body = error?.response?.data
    const text = body?.msg || body?.message || error?.msg
    if (typeof text === 'string' && text) return text
    if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return '加载安排超时，请稍后重试'
    if (error?.response?.status) return `请求失败，请稍后重试（HTTP ${error.response.status}）`
    if (error?.message === 'Network Error') return '网络连接失败，请检查网络后重试'
    return error?.message || '请求失败，请稍后重试'
}

export function notifyRequestError(error: any) {
    if (isRequestCanceled(error)) return
    // A toast must never replace the original request error.
    try { errorNotifier?.(requestErrorMessage(error)) } catch { /* caller retains the error */ }
}
